import React, { useState } from "react";
import axios from "axios";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { useShop, API } from "../context/ShopContext";

const labels = {
  it: {
    name: "Nome e cognome",
    email: "Email",
    phone: "Telefono",
    subject: "Oggetto",
    message: "Messaggio",
    send: "Invia messaggio",
    sending: "Invio in corso...",
    success: "Messaggio inviato! Ti risponderemo al pi\u00f9 presto.",
    error: "Errore durante l'invio. Riprova pi\u00f9 tardi.",
    required: "Campo obbligatorio",
  },
  en: {
    name: "Full name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    sending: "Sending...",
    success: "Message sent! We will get back to you as soon as possible.",
    error: "Error while sending. Please try again later.",
    required: "Required field",
  },
};

const ContactForm = ({ defaultSubject = "" }) => {
  const { lang } = useShop();
  const c = labels[lang];
  const emptyForm = { name: "", email: "", phone: "", subject: defaultSubject, message: "" };
  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = true;
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = true;
    if (!form.message.trim() || form.message.trim().length < 5) newErrors.message = true;
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, { ...form, lang });
      setSent(true);
      setForm({ ...emptyForm, subject: defaultSubject });
      toast.success(c.success);
    } catch (err) {
      console.error("Contact error", err);
      toast.error(c.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {sent && (
        <div className="idm-contact-sent" data-testid="contact-success">
          <CheckCircle2 size={18} /> {c.success}
        </div>
      )}
      <form onSubmit={handleSubmit} noValidate>
        <div className="idm-form-grid">
          <div className="idm-field half">
            <label htmlFor="cf-name">{c.name} <span className="idm-req">*</span></label>
            <input id="cf-name" name="name" value={form.name} onChange={handleChange} className={errors.name ? "error" : ""} data-testid="contact-name" />
            {errors.name && <span className="idm-field-error">{c.required}</span>}
          </div>
          <div className="idm-field half">
            <label htmlFor="cf-email">{c.email} <span className="idm-req">*</span></label>
            <input id="cf-email" name="email" type="email" value={form.email} onChange={handleChange} className={errors.email ? "error" : ""} data-testid="contact-email" />
            {errors.email && <span className="idm-field-error">{c.required}</span>}
          </div>
          <div className="idm-field half">
            <label htmlFor="cf-phone">{c.phone}</label>
            <input id="cf-phone" name="phone" value={form.phone} onChange={handleChange} data-testid="contact-phone" />
          </div>
          <div className="idm-field half">
            <label htmlFor="cf-subject">{c.subject}</label>
            <input id="cf-subject" name="subject" value={form.subject} onChange={handleChange} data-testid="contact-subject" />
          </div>
          <div className="idm-field">
            <label htmlFor="cf-message">{c.message} <span className="idm-req">*</span></label>
            <textarea id="cf-message" name="message" rows={6} value={form.message} onChange={handleChange} className={errors.message ? "error" : ""} data-testid="contact-message" />
            {errors.message && <span className="idm-field-error">{c.required}</span>}
          </div>
        </div>
        <button type="submit" className="idm-btn-yellow" style={{ animation: "none", marginTop: 20 }} disabled={sending} data-testid="contact-send">
          {sending ? <Loader2 size={16} className="idm-spin" /> : <Send size={15} />}
          {sending ? c.sending : c.send}
        </button>
      </form>
    </>
  );
};

export default ContactForm;
